export default "__VITE_ASSET__Dq1xkAw$__"